import React, { useState, useEffect } from 'react';
import { FiUser, FiUsers } from 'react-icons/fi';
import { FaBuilding, FaRegFileAlt, FaStethoscope } from 'react-icons/fa';

import { BsBookmark, BsFillFileEarmarkPlusFill, BsChat, BsFillDoorOpenFill, BsTv } from 'react-icons/bs';
import { AiOutlineCalendar } from 'react-icons/ai';
import { TbWorld } from 'react-icons/tb';
import { useQuery } from 'react-query';
import API from './API/API';
import { BiFilterAlt } from 'react-icons/bi';
import { IoGitPullRequestSharp } from 'react-icons/io5';
export const Contexthandlerscontext = React.createContext();
export const Contexthandlerscontext_provider = (props) => {
    const { fetchuseauthorization, fetchALLproductsAPI } = API();
    const [hidesidenav_context, sethidesidenav_context] = useState(false);
    const [openloginmodalcontext, setopenloginmodalcontext] = useState(true);
    const [allcachedproductscontext, setallcachedproductscontext] = useState([]);
    const fetchuseauthorizationQueryContext = useQuery(['fetchuseauthorization'], () => fetchuseauthorization(), {
        keepPreviousData: true,
        staleTime: Infinity,
    });
    const [pagesarray_context, setpagesarray_context] = useState([
        // {
        //     name: 'Admins',
        //     isselected: false,
        //     icon: (
        //         <i class={'allcentered'}>
        //             <FiUsers size={20} />
        //         </i>
        //     ),
        //     path: '/admins',
        // },

        {
            name: 'Users',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <FiUser size={20} />
                </i>
            ),
            path: '/users',
        },
        {
            name: 'Clinics',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <FaBuilding size={20} />
                </i>
            ),
            path: '/clinics',
        },

        {
            name: 'Rooms',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <BsFillDoorOpenFill size={20} />
                </i>
            ),
            path: '/rooms',
        },
        {
            name: 'Amenities',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <BsTv size={20} />
                </i>
            ),
            path: '/amenities',
        },
        {
            name: 'Reservations',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <AiOutlineCalendar size={20} />
                </i>
            ),
            path: '/reservations',
        },
        {
            name: 'Not Found Filters',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <BiFilterAlt size={20} />
                </i>
            ),
            path: '/notfoundfilters',
        },
        {
            name: 'Clininc Logs',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <FaRegFileAlt size={20} />
                </i>
            ),
            path: '/cliniclogs',
        },

        {
            name: 'Room Requests',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <IoGitPullRequestSharp size={20} />
                </i>
            ),
            path: '/roomrequests',
        },

        {
            name: 'Countries',
            isselected: false,
            icon: (
                <i class={'allcentered'}>
                    <TbWorld size={20} />
                </i>
            ),
            path: '/countries',
        },

        // {
        //     name: 'Hirings',
        //     isselected: false,
        //     icon: (
        //         <i class={'allcentered'}>
        //             <BsFillFileEarmarkPlusFill size={20} />
        //         </i>
        //     ),
        //     path: '/hirings',
        // },
        // {
        //     name: 'Equipments',
        //     isselected: false,
        //     icon: (
        //         <i class={'allcentered'}>
        //             <FaStethoscope size={20} />
        //         </i>
        //     ),
        //     path: '/equipments',
        // },
    ]);

    const [pagetitle_context, setpagetitle_context] = useState('');
    const setpageactive_context = (route) => {
        var temparr = [...pagesarray_context];
        temparr.forEach((sideelement, index) => {
            if (sideelement.path == route) {
                sideelement['isselected'] = true;
            } else {
                sideelement['isselected'] = false;
            }
        });

        setpagesarray_context([...temparr]);
    };

    return (
        <Contexthandlerscontext.Provider
            value={{
                pagesarray_context,
                setpagesarray_context,
                pagetitle_context,
                setpagetitle_context,
                setpageactive_context,
                hidesidenav_context,
                sethidesidenav_context,
                openloginmodalcontext,
                setopenloginmodalcontext,
                fetchuseauthorizationQueryContext,
                allcachedproductscontext,
                setallcachedproductscontext,
            }}
        >
            {props.children}
        </Contexthandlerscontext.Provider>
    );
};
